'use client'

import { TherapistLink } from '@tebuto/api/public/models/TherapistLink'
import { useComponentTranslation } from '@tebuto/functions/translation.components'
import PlainModal from '@tebuto/modals/PlainModal'
import BookingWidget from '@tebuto/widget/booking-widget/widget'
import Link from 'next/link'
import { useState } from 'react'

interface HeroLinkActionBlockProps {
    link: TherapistLink
    therapistUUID?: string
}

function getLinkButtonTitle(link: TherapistLink): string {
    switch (link.type) {
        case TherapistLink.type.EMAIL:
            return 'E-Mail Schreiben'
        case TherapistLink.type.PHONE:
            return 'Anrufen'
        case TherapistLink.type.WEBSITE:
            return 'Website aufrufen'
        case TherapistLink.type.APPOINTMENT:
            return 'Termin buchen'
        default:
            return 'Sonstiges'
    }
}

function getLinkTarget(link: TherapistLink): string {
    switch (link.type) {
        case TherapistLink.type.EMAIL:
            return `mailto:${link.target}`
        case TherapistLink.type.PHONE:
            return `tel:${link.target}`
        default:
            return link.target
    }
}

export default function HeroLinkActionBlock({ therapistUUID, link }: HeroLinkActionBlockProps) {
    const title = getLinkButtonTitle(link)
    const [isBookingModalOpen, setIsBookingModalOpen] = useState(false)
    const { t } = useComponentTranslation()

    if (link.type === TherapistLink.type.APPOINTMENT) {
        if (!therapistUUID) {
            return null
        }
        return (
            <>
                <button
                    onClick={() => setIsBookingModalOpen(true)}
                    className="inline-flex items-center justify-center px-6 py-3 text-base font-semibold text-primary-700 bg-white rounded-xl shadow-sm shadow-primary-900/10 hover:bg-primary-50 hover:shadow-xl hover:shadow-primary-900/15 transition-all duration-200"
                >
                    {title}
                </button>
                <PlainModal
                    title={t('directory.bookAppointment')}
                    isOpen={isBookingModalOpen}
                    closeHandler={() => setIsBookingModalOpen(false)}
                    className="max-w-max xl:min-w-250 min-h-150"
                    verticalPadding={false}
                >
                    <BookingWidget therapistUUID={therapistUUID} border={false} />
                </PlainModal>
            </>
        )
    }

    const target = getLinkTarget(link)

    return (
        <Link
            href={target}
            target="_blank"
            className="inline-flex items-center justify-center px-6 py-3 text-base font-semibold text-primary-700 bg-white rounded-xl shadow-sm shadow-primary-900/10 hover:bg-primary-50 hover:shadow-xl hover:shadow-primary-900/15 transition-all duration-200"
        >
            {title}
        </Link>
    )
}
